import { MotionConfig } from 'motion/react';
import { AppProviders } from '@/app/AppProviders';
import { AppRouter } from '@/app/router';
import { ErrorBoundary } from '@/components/layout';
import { SkipLink } from '@/components/ui/SkipLink';

export default function App() {
  return (
    // The boundary sits outside the providers so a corrupt stored record is
    // caught too, not just a render fault inside a route.
    <ErrorBoundary>
      {/* `reducedMotion="user"` makes every motion component honour the OS
          setting automatically, rather than each one checking for itself. */}
      <MotionConfig reducedMotion="user">
        <AppProviders>
          <SkipLink />
          <AppRouter />
        </AppProviders>
      </MotionConfig>
    </ErrorBoundary>
  );
}
